export const fallbackLocale = import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE;
export const fallbackCurrency = "EUR";
